import { memo } from 'react';
import {
    Checkbox,
    CheckmarkIcon,
    ClickableArea,
    CloseIcon,
    HStack,
    Table,
    TableBody,
    TableCell,
    TableHeader,
    TableHeaderCell,
    TableRow,
    Text,
    VStack,
} from '@library';
import type {
    PriceProgramAttribute,
    PriceProgramAttributeValue,
    PriceProgramComparison as PriceProgramComparisonProps,
} from '../../../types/customStoryblokComponents';

const AttributeCellValue = memo(
    ({
        attribute,
        attributesValues,
    }: {
        attribute: PriceProgramAttribute;
        attributesValues: PriceProgramAttributeValue[];
    }) => {
        const attributeValue = attributesValues.find(
            attr => attr.id === attribute.id
        );
        if (!attributeValue || attributeValue.value === '') {
            return <div>-</div>;
        }
        if (attributeValue.value === 'yes' || attributeValue.value === 'true') {
            return <CheckmarkIcon mini />;
        }
        if (attributeValue.value === 'no' || attributeValue.value === 'false') {
            return <CloseIcon />;
        }
        return <Text>{attributeValue.value}</Text>;
    }
);

const OverviewTable = ({
    content,
    value,
    onChange,
}: {
    content: PriceProgramComparisonProps;
    value: string;
    onChange: (value: string) => void;
}) => {
    return (
        <Table striped>
            <TableHeader>
                <TableRow>
                    <TableHeaderCell />
                    <>
                        {content.programs.map(program => (
                            <TableHeaderCell key={program.value}>
                                <VStack align="center" gap="gap18">
                                    <Checkbox
                                        checked={value === program.value}
                                        onChange={() => {
                                            onChange(program.value);
                                        }}
                                    />
                                    <ClickableArea
                                        onPress={() => onChange(program.value)}
                                    >
                                        <Text semiBold>{program.name}</Text>
                                    </ClickableArea>
                                </VStack>
                            </TableHeaderCell>
                        ))}
                    </>
                </TableRow>
            </TableHeader>
            <TableBody>
                {content.attributes.map(attribute => (
                    <TableRow key={attribute.id}>
                        <TableCell>
                            <Text>{attribute.name}</Text>
                        </TableCell>
                        <>
                            {content.programs.map(program => {
                                return (
                                    <TableCell key={program.value}>
                                        <HStack justify="center">
                                            <AttributeCellValue
                                                attribute={attribute}
                                                attributesValues={
                                                    program.attributes
                                                }
                                            />
                                        </HStack>
                                    </TableCell>
                                );
                            })}
                        </>
                    </TableRow>
                ))}
            </TableBody>
        </Table>
    );
};

export default memo(OverviewTable);
